import { render, staticRenderFns } from "./OAuthVendorList.vue?vue&type=template&id=624462fb"
import script from "./OAuthVendorList.vue?vue&type=script&lang=ts"
export * from "./OAuthVendorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports